import { useState } from 'react';
import PropTypes from 'prop-types';

import ContentCard from '../ContentCard/ContentCard';
import ModalContent from '../ModalContent/ModalContent';
import classes from './ContentContainer.module.css';
import isMobileViewHook from '../../hooks/isMobileView';

const ContentContainer = ({ allContent, color, description, onBackToTop }) => {
  const isMobileView = isMobileViewHook();
  const characters = isMobileView ? 25 : 35;
  let maxCharacters = 0;
  allContent.forEach((element) => {
    if (element.title.length > maxCharacters) {
      maxCharacters = element.title.length;
    }
  });
  const spaces = maxCharacters / characters;
  const height = Math.trunc(spaces) < spaces ? Math.trunc(spaces) + 1 : spaces;

  const [showModal, setShowModal] = useState(false);
  const [currentContent, setCurrentContent] = useState();
  const toggleModal = () => setShowModal((prevShowModal) => !prevShowModal);
  const selectHandler = (selectedContent) => {
    toggleModal();
    setCurrentContent(selectedContent);
  };
  return (
    <div className={classes.allContentContainer}>
      <ModalContent
        show={showModal}
        onCloseModal={toggleModal}
        content={currentContent}
      />

      <p className={classes.description}>{description}</p>

      {allContent.map((content) => (
        <div key={content.id} className={classes.contentContainer}>
          <ContentCard
            height={height}
            color={color}
            content={content}
            onBackToTop={onBackToTop}
            onSelect={selectHandler}
          />
        </div>
      ))}
    </div>
  );
};

ContentContainer.propTypes = {
  description: PropTypes.string.isRequired,
  allContent: PropTypes.arrayOf(
    PropTypes.shape({
      viewType: PropTypes.oneOf(['FILE', 'GENERAL']),
      thumbnail: PropTypes.arrayOf(
        PropTypes.shape({
          url: PropTypes.string,
        })
      ),
      imageSrc: PropTypes.string,
      description: PropTypes.string,
      enable: PropTypes.bool,
      id: PropTypes.number,
      size: PropTypes.string,
      title: PropTypes.string,
      type: PropTypes.string,
      downloadable: PropTypes.bool,
    })
  ).isRequired,
  color: PropTypes.string.isRequired,
  onBackToTop: PropTypes.func,
};
ContentContainer.defaultProps = {
  onBackToTop: () => {},
};

export default ContentContainer;
